export default "/WebApp/dist/assets/svg/black-radio-checked.svg";